type ApiEndpointName = 'presignedUrl' | 'submit' | 'partners';

const API_ENDPOINTS: Record<ApiEndpointName, string> = {
  presignedUrl: '/api/v1/pre-signed-url',
  submit: '/api/v1/submit',
  partners: '/api/v1/partners',
};

export function getApiEndpoint(name: ApiEndpointName): string {
  return API_ENDPOINTS[name];
}
